import apiClient from '../utils/apiClient';

// Get all labels for the company
export async function getLabels() {
  const response = await apiClient.get('/api/labels/');
  return response.data;
}

// Search labels by query (for autocomplete)
export async function searchLabels(query = "") {
  const response = await apiClient.get('/api/labels/search', {
    params: query ? { query } : {}
  });
  return response.data;
}

// Create a new label
export async function createLabel({ name, color, description }) {
  const response = await apiClient.post('/api/labels/', { name, color, description });
  return response.data;
}

// Update a label
export async function updateLabel(labelId, { name, color, description }) {
  const response = await apiClient.put(`/api/labels/${labelId}`, { name, color, description });
  return response.data;
}

// Delete a label
export async function deleteLabel(labelId) {
  const response = await apiClient.delete(`/api/labels/${labelId}`);
  return response.data;
}

// Get labels for a specific lead
export async function getLeadLabels(leadId) {
  const response = await apiClient.get(`/api/labels/lead/${leadId}`);
  return response.data;
}

// Set labels for a lead
export async function setLeadLabels(leadId, labelIds) {
  const response = await apiClient.put(`/api/labels/lead/${leadId}`, { label_ids: labelIds });
  return response.data;
}

// Get labels for a specific project
export async function getProjectLabels(projectId) {
  const response = await apiClient.get(`/api/labels/project/${projectId}`);
  return response.data;
}

// Set labels for a project
export async function setProjectLabels(projectId, labelIds) {
  const response = await apiClient.put(`/api/labels/project/${projectId}`, { label_ids: labelIds });
  return response.data;
}
